import UpdateIcon from '@mui/icons-material/Update';
import {Button, Tooltip} from '@mui/material';
import {useTranslation} from '../i18n/hooks/useTranslation';
import {ComponentWithoutChildren} from '../react/types';
import {useAppUpdate} from './hooks/useAppUpdate';

export const AppUpdateNotification: ComponentWithoutChildren = () => {
  const {needRefresh, updateApp} = useAppUpdate();
  const {translate} = useTranslation('main');

  if (!needRefresh) {
    return null;
  }

  return (
    <Tooltip arrow title={translate('main:pwa.update.tooltip')}>
      <Button
        aria-label={translate('main:pwa.update.tooltip')}
        color="secondary"
        data-testid="AppUpdateNotification"
        onClick={updateApp}
        size="small"
        startIcon={<UpdateIcon />}
        variant="contained"
      >
        {translate('main:pwa.update.label')}
      </Button>
    </Tooltip>
  );
};
